import React from "react";

export const Footer = () => {
    return (
        <footer>
            <p>copyleft mellim.io</p>
        </footer>
    )
}